/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { changeGreetingPriorityModelSchema } from "../changeGreetingPriorityModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

/**
 * @description Приоритеты изменены
 */
export const putApiGreetingsOrder200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации | Количество переданных шаблонов не совпадает с количеством существующих активных шаблонов
 */
export const putApiGreetingsOrder400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiGreetingsOrder401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiGreetingsOrder403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Шаблон приветственного экрана не найден
 */
export const putApiGreetingsOrder404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiGreetingsOrder500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const putApiGreetingsOrderMutationRequestSchema = z.array(z.lazy(() => changeGreetingPriorityModelSchema)).describe("Тело запроса")

export const putApiGreetingsOrderMutationResponseSchema = z.lazy(() => putApiGreetingsOrder200Schema)